import cc from 'store/util/createReduxConstant';

export const FETCH_TASKS = cc('FETCH_TASKS');
export const FETCH_TASKS_SUCCESS = cc('FETCH_TASKS_SUCCESS');
export const FETCH_TASKS_FAIL = cc('FETCH_TASKS_FAIL');
